export default {
	getConnectInvoices(state) {
		return state.ConnectInvoices;
	},
	getConnectInvoicesTotal(state) {
		return state.ConnectInvoicesTotal;
	},
	getConnectInvoicesTaxaxion(state) {
		return state.ConnectInvoicesTaxaxion;
	},
	getConnectInvoicesTaxaxionTotal(state) {
		return state.ConnectInvoicesTaxaxionTotal;
	},
	invoicesAutoLoad(state) {
		return state.InvoicesAutoLoad;
	},
	getTaxCodeCQT(state) {
		return state.TaxCodeCQT;
	},
	getConnectOutInvoices(state) {
		return state.ConnectOutInvoices;
	},
	getConnectOutInvoicesTotal(state) {
		return state.ConnectOutInvoicesTotal;
	},
	outInvoicesAutoLoad(state) {
		return state.OutInvoicesAutoLoad;
	},
	getDataConnectTaxaxion(state) {
		return state.DataConnectTaxaxion;
	},
	getDataConnectSupplier(state) {
		return state.DataConnectSupplier;
	},
	IsLoadingTotalRecords(state) {
		return state.IsLoadingTotalRecords;
	},
	IsLoadingTotalTypeInvoice(state) {
		return state.IsLoadingTotalTypeInvoice;
	},
	TotalTypeInvoiceAutoLoad(state) {
		return state.TotalTypeInvoiceAutoLoad;
	},
	NumberInvoiceAutoRespone(state) {
		return state.NumberInvoiceAutoRespone;
	},
	ConnectInvoiceDetails(state) {
		return state.ConnectInvoiceDetails;
	},
	ConnectOutInvoiceDetails(state) {
		return state.ConnectOutInvoiceDetails;
	},
	TotalInvoiceStatus(state) {
		return state.TotalInvoiceStatus;
	},
	TotalOutInvoiceStatus(state) {
		return state.TotalOutInvoiceStatus;
	},
	IsLoadingTotalInvoiceStatus(state) {
		return state.IsLoadingTotalInvoiceStatus;
	},
	timeServerRemind(state) {
		return state.TimeServerRemind;
	},
	/**
	 * Hàm check xem form mất kết nối với CQT đã show hay chưa
	 * @param {*} state
	 * @returns
	 */
	isShowFormDisonnectTaxaxion(state) {
		return state.isShowFormDisconnectActive;
	},
	/**
	 * Hàm check xem form kết nối với cơ quan thuế có đang mở hay không
	 * @param {*} state
	 * @returns
	 */
	isShowFormConnectTaxaxion(state) {
		return state.isShowFormConnectActive;
	},
	IsLoadingTotalRecordsInbot(state) {
		return state.IsLoadingTotalRecordsInbot;
	},
	IsLoadingTotalRecordsOutbot(state) {
		return state.IsLoadingTotalRecordsOutbot;
	},
	//PBI 625836 — tab "Hóa đơn đang tải"
	InvoiceLoadingList(state) {
		return state.InvoiceLoadingList;
	},
	InvoiceLoadingTotal(state) {
		return state.InvoiceLoadingTotal;
	},
	IsLoadingInvoiceLoading(state) {
		return state.IsLoadingInvoiceLoading;
	},
	OutInvoiceLoadingList(state) {
		return state.OutInvoiceLoadingList;
	},
	OutInvoiceLoadingTotal(state) {
		return state.OutInvoiceLoadingTotal;
	},
	IsLoadingOutInvoiceLoading(state) {
		return state.IsLoadingOutInvoiceLoading;
	}
};
